<h1 class="title ic1-mt-48" [HTMLTranslate]="'ACTIVATION_STEPS_PAGE.TITLE'"></h1>
<div class="mobile-title" [HTMLTranslate]="'ACTIVATION_STEPS_PAGE.MOBILE_TITLE'"></div>
<app-force-pwd></app-force-pwd>
<app-first-emis></app-first-emis>
